import classnames from 'classnames/bind'
import React from 'react'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import RichText, { RichTextBlock } from '~/components/Abstracts/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ProductTwoColsWYSIWYGProps {
  className?: string
  leftText?: RichTextBlock
  rightText?: RichTextBlock
}

function ProductTwoColsWYSIWYG({
  className,
  leftText,
  rightText,
}: ProductTwoColsWYSIWYGProps) {
  const WYSIWYGStyle = useStyle({
    textPreset: GlobalTextPreset.RichTextEditorial,
  })

  const gridStyle = useStyle({
    grid: GlobalGridPreset.BASE_GRID,
  })

  const hasOnlyOneText = !leftText || !rightText

  return (
    <div
      className={cx(css.ProductTwoColsWYSIWYG, className, { hasOnlyOneText })}>
      {(leftText || rightText) && (
        <div className={gridStyle}>
          {leftText && (
            <RichText
              className={cx(css.wysiwyg, css.leftText, WYSIWYGStyle)}
              render={leftText}
            />
          )}
          {rightText && (
            <RichText
              className={cx(css.wysiwyg, css.rightText, WYSIWYGStyle)}
              render={rightText}
            />
          )}
        </div>
      )}
    </div>
  )
}

ProductTwoColsWYSIWYG.defaultProps = {}

export default ProductTwoColsWYSIWYG
